import React from 'react'
import { Control, FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { t } from 'ttag'
import { activityTypes, FormData } from '../../ChallengeAdmin'
import Typography from '@material-ui/core/Typography'
import { List, ListItem, ListItemIcon, ListItemText, TextField } from '@material-ui/core'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { Capacitor } from '@capacitor/core'
import { scrollToBottom } from '../../../../common/helpers/scroll'
import { YumActivityIcon } from '../../../../components/YumActivityIcon/YumActivityIcon'

interface ChallengeStepPeriodProps {
  setValue: UseFormSetValue<FormData>
  register: UseFormRegister<FormData>
  errors: FieldErrors<FormData>
  formStep: number
  activityType: CustomTypeCategory
}

export default function ChallengeStepActivityType(props: ChallengeStepPeriodProps) {
  const { setValue, register, errors, formStep, activityType } = props

  const filteredActivityTypes = activityTypes.filter((a) => a.value !== CustomTypeCategory.POINTS)
  const filteredPointTypes = activityTypes.filter((a) => a.value === CustomTypeCategory.POINTS)
  const filteredMostPopularTypes = filteredActivityTypes.filter(
    (a) =>
      [CustomTypeCategory.STEPS, CustomTypeCategory.DISTANCE, CustomTypeCategory.EXERCISE].includes(a.value) &&
      a.usesIntegration,
  )
  const filteredOtherAutomatedTypes = filteredActivityTypes.filter(
    (a) =>
      ![CustomTypeCategory.STEPS, CustomTypeCategory.DISTANCE, CustomTypeCategory.EXERCISE].includes(a.value) &&
      a.usesIntegration,
  )

  const setActivityTypeValue = (value: any) => {
    setValue('activityType', value)

    if (value === CustomTypeCategory.CUSTOM) {
      setTimeout(() => {
        scrollToBottom()
      }, 0)
    }
  }

  const activityTypesListItems = (
    {
      label,
      value,
    }: {
      label: string
      value: any
    },
    index: number,
  ) => {
    const labelId = `type-${index}`
    return (
      <ListItem
        key={index}
        role={undefined}
        button
        disableRipple
        selected={activityType === value}
        onClick={() => setActivityTypeValue(value)}
      >
        <ListItemIcon>
          {activityType === value ? (
            <YumActivityIcon category={value} />
          ) : (
            <YumActivityIcon category={value} color={'darkGray'} isInactive={true} />
          )}
        </ListItemIcon>
        <ListItemText id={labelId} primary={label} />
      </ListItem>
    )
  }

  const manualEntryTypes = filteredActivityTypes
    .filter(({ usesIntegration, value }) => !usesIntegration && value !== CustomTypeCategory.CUSTOM)
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <div style={{ marginBottom: 10 }}>
      <Typography
        variant="subtitle2"
        style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11 }}
      >{t`Most popular`}</Typography>
      <List>{filteredMostPopularTypes.map(activityTypesListItems)}</List>

      <Typography
        variant="subtitle2"
        style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11 }}
      >{t`Wellness points`}</Typography>
      <List>{filteredPointTypes.map(activityTypesListItems)}</List>

      <Typography
        variant="subtitle2"
        style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11 }}
      >{t`Automated sync`}</Typography>
      <List>
        {filteredOtherAutomatedTypes.filter(({ usesIntegration }) => usesIntegration).map(activityTypesListItems)}
      </List>

      <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11 }}>
        {t`Manual entry`}
      </Typography>
      <List>{manualEntryTypes.map(activityTypesListItems)}</List>

      <Typography
        variant="subtitle2"
        style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11 }}
      >{`${t`Custom`} (${t`Manual entry`.toLowerCase()})`}</Typography>

      <List>
        {filteredActivityTypes.filter(({ value }) => value == CustomTypeCategory.CUSTOM).map(activityTypesListItems)}
      </List>

      {activityType === CustomTypeCategory.CUSTOM && (
        <>
          <TextField
            style={{ marginTop: 0, width: '100%' }}
            label={t`Enter activity name`}
            {...register('customActivityName', { required: formStep === 1 })}
            margin="normal"
            error={!!errors.customActivityName}
            variant="filled"
            InputProps={{
              disableUnderline: true,
            }}
            inputProps={{
              id: 'customActivityName',
            }}
            autoFocus={Capacitor.getPlatform() === 'web'}
          />
        </>
      )}
    </div>
  )
}
